import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { Observable } from "rxjs";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { AuthService } from "../auth/auth.service";
import { Contact } from "src/app/models/contact-model";
import { firstValueFrom } from 'rxjs';

const httpOptions = {
  headers: new HttpHeaders({ "Content-Type": "application/json" }),
};

@Injectable({
  providedIn: "root",
})
export class ContactService {
  entity: string = "/contacts";

  constructor(private http: HttpClient, private authService: AuthService) {}

  create(contact: Contact): Observable<any> {
    return this.http.post(
      environment.api + this.entity,
      {
        data: contact,
      },
      httpOptions
    );
  }

  send(body: any) {
    return this.http.post(environment.api + this.entity + "/send", body, {
      headers: {
        Authorization: "Bearer " + this.authService.currentUserValue.token,
        "Content-Type": "application/json",
      },
    });
  }

  count_no_read(): Promise<any> {
    return firstValueFrom(
      this.http.get(environment.api + this.entity + "/get/count-no-read", {
        headers: {
          Authorization: "Bearer " + this.authService.currentUserValue.token,
          "Content-Type": "application/json",
        },
      })
    );
  }

}
